import { render } from "./Contactus.vue?vue&type=template&id=b71d81e6"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__